import React from "react";
import { useNavigate } from "react-router-dom";

export default function SumupPayWidget ({ checkoutId, total, handleResponse }) {
  const navigate = useNavigate();
  const widgetRef = React.useRef(null);

  React.useEffect(() => {
    if (!checkoutId || !window.SumUpCard) return;

    const widget = window.SumUpCard.mount({
      checkoutId,
      amount: total.toFixed(2),
      currency: 'EUR',
      locale: 'fr-FR',
      onResponse: (result) => {
        console.log("Résultat paiement:", result);
        if (result === 'sent') { return }
        else handleResponse()
      },
      onError: (err) => {
        console.error("Erreur widget:", err);
        alert("Erreur lors du paiement.");
      }
    });

    widgetRef.current = widget;

    return () => {
      widget?.unmount();
    };
  }, [checkoutId, total]);

  return <div id="sumup-card" />;
}